import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';

const LockerMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
        title: "Home",
        link: "#home",
        },
        {
        title: "About",
        link: "#about",
        },
        {
        title: "How It Works",
        link: "#howitworks",
        },
        {
        title: "Token Details",
        link: "#details",
        },
        {
        title: "FAQ",
        link: "#faq",
        },
        {
        title: "TeleGram",
        link: "https://t.me/pulsemixerorg",
        target:"blank",
        },
        {
        title: "Launch Dapp",
        link: "https://dapp.pulsemixer.org",
        },
    ];
  return (
    <Container maxWidth="xxl">
        <DesktopMenu menuList={menuList} />
        <MobileMenu menuList={menuList} />
    </Container>
  )
}

export default LockerMenu